import React from "react"

import { useProductConfiguratorProductInfoContext } from "../../model/ProductConfiguratorProductInfoContext"
import { ProductConfiguratorStepSummaryCard } from "../step-summary-card/ProductConfiguratorStepSummaryCard"
import { ProductConfiguratorLoadingStep } from "./ProductConfiguratorLoadingStep"
import { useProductConfiguratorStepSummaries } from "./hooks/useProductConfiguratorStepSummaries"

export const ProductConfiguratorSummaryStep = React.memo(() => {
  const { isLoadingProductInformation } =
    useProductConfiguratorProductInfoContext()
  const summaries = useProductConfiguratorStepSummaries()

  if (isLoadingProductInformation) {
    return <ProductConfiguratorLoadingStep />
  }

  if (!summaries.length) {
    return null
  }

  return (
    <div className="product-configurator-summary-step">
      <div className="product-configurator-summary-step__cards">
        {summaries.map(summary => (
          <ProductConfiguratorStepSummaryCard
            key={summary.step}
            title={summary.title}
            subtitle={summary.subtitle}
            onEdit={summary.onEdit}
          >
            {summary.content}
          </ProductConfiguratorStepSummaryCard>
        ))}
      </div>
    </div>
  )
})
